import { createAction, props } from '@ngrx/store';
import { SmartHomeComponent } from '@vi-iot/client';

export namespace SmartHomeComponentsActions {
  export enum Type {
    GET_SMART_HOME_COMPONENTS = '[SHC] Get smart home components',
    GET_SMART_HOME_COMPONENTS_ERROR = '[SHC] Get smart home components error',
    GET_SMART_HOME_COMPONENTS_SUCCESS = '[SHC] Get smart home components success',
    UPDATE_SMART_HOME_COMPONENTS = '[SHC] Update smart home components',
    UPDATE_SMART_HOME_COMPONENTS_ERROR = '[SHC] Update smart home components error',
    UPDATE_SMART_HOME_COMPONENTS_SUCCESS = '[SHC] Update smart home components success',
  }

  export const getSmartHomeComponents = createAction(
    Type.GET_SMART_HOME_COMPONENTS,
    props<{
      installationId: number;
    }>()
  );

  export const getSmartHomeComponentsError = createAction(
    Type.GET_SMART_HOME_COMPONENTS_ERROR,
    props<{
      error: any;
    }>()
  );

  export const getSmartHomeComponentsSuccess = createAction(
    Type.GET_SMART_HOME_COMPONENTS_SUCCESS,
    props<{
      smartHomeComponents: SmartHomeComponent[];
    }>()
  );

  export const updateSmartHomeComponents = createAction(
    Type.UPDATE_SMART_HOME_COMPONENTS,
    props<{
      installationId: number;
      smartHomeComponents: SmartHomeComponent[];
    }>()
  );

  export const updateSmartHomeComponentsError = createAction(
    Type.UPDATE_SMART_HOME_COMPONENTS_ERROR,
    props<{
      error: any;
    }>()
  );

  export const updateSmartHomeComponentsSuccess = createAction(
    Type.UPDATE_SMART_HOME_COMPONENTS_SUCCESS,
    props<{
      smartHomeComponents: SmartHomeComponent[];
    }>()
  );
}
